// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"30":"963fb42cbdc434ed","998":"c5bf17e9838a25df","2450":"da52619ef0421423"}[chunkId] + ".js";
};